import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTrashBinGhostLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill={props.color} fillRule='evenodd' clipRule='evenodd' opacity={0.4}>
      <path d='M14.286 10.003a1 1 0 0 1 .926 1.068l-.429 6a1 1 0 1 1-1.995-.142l.429-6a1 1 0 0 1 1.069-.926M9.714 10.003a1 1 0 0 1 1.07.926l.428 6a1 1 0 0 1-1.995.142l-.429-6a1 1 0 0 1 .926-1.068' />
    </g>
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M8 6c0-1.105.277-2.168 1.055-2.945C9.832 2.277 10.895 2 12 2s2.168.277 2.945 1.055C15.723 3.832 16 4.895 16 6h4a1 1 0 1 1 0 2h-.069l-.8 11.214A3 3 0 0 1 16.137 22H7.862a3 3 0 0 1-2.992-2.786L4.069 8H4a1 1 0 0 1 0-2zm2.469-1.531C10.739 4.199 11.203 4 12 4s1.261.199 1.531.469S14 5.203 14 6h-4c0-.797.199-1.261.469-1.531M6.865 19.07 6.074 8h11.852l-.79 11.071a1 1 0 0 1-.998.929H7.862a1 1 0 0 1-.997-.929'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTrashBinGhostLine)
export default ForwardRef
